import { DirectiveLocation, GraphQLDirective } from 'graphql';
export let Directives = /*#__PURE__*/function (Directives) {
  Directives["CUSTOM"] = "custom";
  return Directives;
}({});
export const CustomDirective = new GraphQLDirective({
  name: Directives.CUSTOM,
  locations: [DirectiveLocation.QUERY, DirectiveLocation.MUTATION]
});